"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupEMPTY_ENV_SECRET = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

var texts_1 = require("../texts");

function setupEMPTY_ENV_SECRET(builder) {
  builder.validator(validator_id_1.ValidatorID.EMPTY_ENV_SECRET).category(categories_1.ValidatorCategory.Container).subCategory(categories_1.ValidatorSubCategory.EnvironmentVariables).title('Empty Secret used in container environment variables').description("You can use Secrets as values for container environment variables.\nThis validator detects when a Secret used as a source for environment variables is empty.\nBecause of that, no environment variables will be sources from the Secret.\n").affectedAllWorkloads().example("\nkind: Deployment\nspec:\n  template:\n    spec:\n      containers:\n        - name: my-container\n          envFrom:\n            - secretRef:\n                name: my-secret   # This Secret is empty\n").example("\nkind: Secret\nmetadata:\n    name: my-secret\ndata: {}                          # Empty data or no data at all\n").resolution(texts_1.RESOLUTION_TEXT.populateEnvVarsData('Secret')).resolution(texts_1.RESOLUTION_TEXT.deleteEnvVarsSource('Secret')).externalLink('https://kubernetes.io/docs/reference/kubernetes-api/workload-resources/pod-v1/#environment-variables');
}

exports.setupEMPTY_ENV_SECRET = setupEMPTY_ENV_SECRET;